// src/config.js
export const BASE_URL = "https://patmitracbs.in/api";
export const FILE_BASE_URL = "https://patmitracbs.in";

// export const BASE_URL = "https://localhost:7231/api";
// export const FILE_BASE_URL = "https://localhost:7231";